export default __webpack_public_path__ + "static/media/flag_check.8246af30.svg";